/* eslint-disable */

// import Swiper bundle with all modules installed
import Swiper from 'swiper/bundle';
// import styles bundle
import 'swiper/css/bundle';

/**
 * WordPress dependencies
 */
import { getContext, store } from '@wordpress/interactivity';

// Interactivy store for the Dynamic Block Slider.
const { state, callbacks } = store('bb/dynamic-block-slider', {
  actions: {
    init() {
      const ctx = getContext();
      const id = ctx?.id;
      const config = ctx?.config ? JSON.parse(ctx?.config) : {};

      const sliderEl = document.querySelector(`.swiper.slider-${id}`);
      if (sliderEl) {
        if (config.pagination) {
          const paginationDiv = document.createElement('div');
          paginationDiv.className = 'swiper-pagination';
          sliderEl.appendChild(paginationDiv);
        }

        if (config.navigation) {
          const prevBtn = document.createElement('div');
          prevBtn.className = 'swiper-button-prev';
          sliderEl.appendChild(prevBtn);

          const nextBtn = document.createElement('div');
          nextBtn.className = 'swiper-button-next';
          sliderEl.appendChild(nextBtn);
        }

        // Peek preview
        if (config.showPeek && config.peekAmount) {
          const totalSlides = sliderEl.querySelectorAll('.swiper-slide').length;
          const originalSlidesPerView = config.slidesPerView || 1;
          let peekFraction = config.peekAmount / 100;

          if (config.centeredSlides) {
            peekFraction *= 2;
          }

          const adjustedSlidesPerView = originalSlidesPerView + peekFraction;

          config.watchSlidesProgress = true;

          if (config.peekTransparency !== undefined) {
            sliderEl.style.setProperty(
              '--bb-slider-peek-transparency',
              config.peekTransparency / 100,
            );
          }

          if (totalSlides > adjustedSlidesPerView) {
            config.slidesPerView = adjustedSlidesPerView;
          }
        }
      }

      new Swiper(`.swiper.slider-${id}`, config);
    },
  },
});
